export interface IFLAT_AND_REDUCING_RATE_FORMULA {
  loanAmount: number;
  loanTenure: number;
  rateOfInterest: number;
  calculatorType: 'FLAT' | 'REDUCING';
}

export const FLAT_AND_REDUCING_RATE_FORMULA = ({
  loanAmount,
  loanTenure,
  rateOfInterest,
  calculatorType,
}: IFLAT_AND_REDUCING_RATE_FORMULA) => {
  loanAmount = Number(loanAmount);
  loanTenure = Number(loanTenure);
  rateOfInterest = Number(rateOfInterest);
  if (!loanAmount || !loanTenure || !rateOfInterest || !calculatorType) {
    return {
      monthlyEmi: 0,
      totalInterest: 0,
      totalAmount: 0,
    };
  }

  let monthlyEmi = 0;
  let totalInterest = 0;
  let totalAmount = 0;

  if (calculatorType === 'FLAT') {
    totalInterest = (loanAmount * rateOfInterest * loanTenure) / 100;
    totalAmount = loanAmount + totalInterest;
    monthlyEmi = totalAmount / (loanTenure * 12);
  } else if (calculatorType === 'REDUCING') {
    const monthlyInterestRate = rateOfInterest / (100 * 12);
    const totalPayments = loanTenure * 12;
    monthlyEmi =
      (loanAmount *
        monthlyInterestRate *
        Math.pow(1 + monthlyInterestRate, totalPayments)) /
      (Math.pow(1 + monthlyInterestRate, totalPayments) - 1);
    totalAmount = monthlyEmi * totalPayments;
    totalInterest = totalAmount - loanAmount;
  }

  return {
    monthlyEmi: Math.round(monthlyEmi),
    totalInterest: Math.round(totalInterest),
    totalAmount: Math.round(totalAmount),
  };
};
